module.exports = __webpack_public_path__ + "f5fca7ef153c40793bcb79028192a9de.png";